export class Routes {
  // GET
  static getAvailableFeatures = (campaignUuid: string): string => `/api/feature/${campaignUuid}`
  static getAvailableCompanyFeatures = (companyUuid: string): string => `/api/templates/${companyUuid}`
  static getFonts = (): string => "/api/available-fonts"
  static getAllFeatures = (): string => "/api/feature/all"
}
